import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";


export const createShowLogsRequestEventSlice = (set, get) => ({
    logsRequestEvent: {
        loading: false,
        data: [],
        filtered: []
    },
    
    getLogsRequestEvent: async (requestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ logsRequestEvent: { ...state.logsRequestEvent, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/crm/insurance/${requestId}/action-log`,
                headers: { token },
            });
            set(state => ({ logsRequestEvent: { loading: false, data: resp.data?.ActionLogs, filtered: resp.data?.ActionLogs } }));
        } catch (error) {
            set(state => ({ logsRequestEvent: { ...state.logsRequestEvent, loading: false } }));
        }
    }
});